var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "link-bar" }, [
    _c("div", { staticClass: "flex-container" }, [
      _c("div", { staticClass: "flex-col flex-12" }, [
        _c(
          "div",
          { staticClass: "flex-row flex-1 link-bar-row" },
          [
            _c(
              "router-link",
              {
                staticClass: "flex-col link-box pl-1 pr-1 bl",
                attrs: { to: "/report" },
              },
              [_vm._v("Report")]
            ),
            _vm.hasEditAccess
              ? _c(
                  "router-link",
                  {
                    staticClass: "flex-col link-box pl-1 pr-1 bl",
                    attrs: { to: "configuration" },
                  },
                  [_vm._v("Configuration")]
                )
              : _vm._e(),
            _vm.hasEditAccess
              ? _c(
                  "router-link",
                  {
                    staticClass: "flex-col link-box pl-1 pr-1 bl",
                    attrs: { to: "/kpi-mappings" },
                  },
                  [_vm._v("KPI Mappings")]
                )
              : _vm._e(),
            _vm.hasEditAccess
              ? _c(
                  "router-link",
                  {
                    staticClass: "flex-col link-box pl-1 pr-1 bl",
                    attrs: { to: "/data-management" },
                  },
                  [_vm._v("Data Management")]
                )
              : _vm._e(),
            _vm.hasEditAccess
              ? _c(
                  "router-link",
                  {
                    staticClass: "flex-col link-box pl-1 pr-1 bl",
                    attrs: { to: "/comment" },
                  },
                  [_vm._v("UI Text")]
                )
              : _vm._e(),
            _c(
              "router-link",
              {
                staticClass: "flex-col link-box pl-1 pr-1 bl",
                attrs: { to: "/line-of-sight" },
              },
              [_vm._v("Line of Sight")]
            ),
            _vm.hasEditAccess
              ? _c(
                  "router-link",
                  {
                    staticClass: "flex-col link-box pl-1 pr-1 bl",
                    attrs: { to: "/changelog" },
                  },
                  [_vm._v("Change Log")]
                )
              : _vm._e(),
            _vm.hasEditAccess
              ? _c(
                  "a",
                  {
                    staticClass: "link-box help-wiki pl-2 pr-1 bl",
                    attrs: {
                      href: "https://wiki.intranet.uniper.energy/sales/display/COODE/Navigation+in+EAS",
                      target: "_blank",
                    },
                  },
                  [
                    _c("font-awesome-icon", {
                      staticClass: "mr-1",
                      attrs: { icon: ["fas", "question-circle"] },
                    }),
                    _vm._v("Wiki"),
                  ],
                  1
                )
              : _vm._e(),
            _c("div", { staticClass: "br" }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "flex-col flex-1" }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }